import { useState, useEffect } from 'react';
import Storage from './Storage';

export const useAuthenticatedImage = (src) => {
    const [data, setData] = useState({ url: null, loading: true, error: null });

    useEffect(() => {
        let objectUrl = null;
        setData({ url: null, loading: true, error: null });
        
        const loadImage = async () => {
        try {
            var reply = Storage.GetToken()
            if(reply == null)  throw new Error('No Token');
            var token = reply["userToken"];
            const response = await fetch(src, {
                headers: { 'Authorization': `Token ${token}` }
            });
            
            if (!response.ok) throw new Error('Failed to fetch image');

            const blob = await response.blob();
            objectUrl = URL.createObjectURL(blob);
            setData({ url: objectUrl, loading: false, error: null });
        } catch (err) {
            setData({ url: null, loading: false, error: err.message });
        }
        };

        loadImage();

        // Cleanup: This is vital to prevent memory leaks in lists!
        return () => {
        if (objectUrl) URL.revokeObjectURL(objectUrl);
        };
    }, [src]);

    return data;
};